import $ from "jquery";
import Foundation from "foundation-sites";
import HtmlElement from '../../../Elements/HtmlElement';
import {Selectors, Constants} from '../Settings';
import {$body, CLEAN_URL} from "../../../Constants";

const AdvisorForm = (() => {

	class AdvisorForm extends HtmlElement {

		onReady() {
			super.onReady();

			this.currentUpdateRequest = null;

			this.zipInput = this._$element.find(Selectors.ZIP_INPUT);
			this.countrySelect = this._$element.find(Selectors.COUNTRY_SELECT);
			this.tankSizeInput = this._$element.find(Selectors.TANK_SIZE_INPUT);
			this.waterDemandInput = this._$element.find(Selectors.WATER_DEMAND_INPUT);
			this.waterYieldInput = this._$element.find(Selectors.WATER_YIELD_INPUT);
			this.roofTypeSelect = this._$element.find(Selectors.ROOF_TYPE_SELECT);
			this.roofCoefficientInput = this._$element.find(Selectors.ROOF_COEFFICIENT_INPUT);
			this.calculationsContainer = $(Selectors.CALCULATIONS_CONTAINER);
			this.resultsContainer = $(Selectors.RESULTS_CONTAINER);
			this.loadingIndicator = $(Selectors.LOADING_INDICATOR);
			this.tankSizeTooltip = $(Selectors.TANK_SIZE_TOOLTIP);
			this.pdfExportForm = $(Selectors.PDF_EXPORT_FORM);
			this.roofAreaInput = $(Selectors.ROOF_AREA_INPUT);
			this.roofAreaDummyInput = $(Selectors.ROOF_AREA_DUMMY_INPUT);
			this.numberOfPeopleInput = $(Selectors.NUMBER_OF_PEOPLE_SELECTOR);
			this.exportPdfResults = $(Selectors.EXPORT_PDF_RESULTS);

			// overwrite default settings
			this.overwriteSettings();

			this.errors = {
				yieldInsufficient: $(Selectors.ERROR_YIELD_INSUFFICIENT)
			};

			this.waterDemandByUse = {};

			// recover form data saved in local storage
			const formData = this.recoverFormData();
			if(formData) {
				this.setFormData(formData, this._$element[0]);
            }

            if (this.zipInput.length) {
                //this.initPlacesAutocomplete();
            }

            this.tankSizeTooltip.data('originaltooltip', this.tankSizeTooltip.attr('title'));
            this.tankSizeTooltip.attr('data-tooltip', '');

            this.bindHandlers();
            this.updateResults();
        }

        async initPlacesAutocomplete() {
            const {Autocomplete} = await google.maps.importLibrary("places")
            this.addressAutocomplete = new Autocomplete(this.zipInput[0], {
                types: ['(regions)'],
                componentRestrictions: {country: Constants.countryCodes[parseInt(this.countrySelect.val())]}
            });
        }

		overwriteSettings() {
			const settings = this._$element.data();
			if(settings.consumptionwc && !isNaN(settings.consumptionwc)) {
				Constants.consumptionByUse[0] = settings.consumptionwc
			}
			if(settings.consumptionwashing && !isNaN(settings.consumptionwashing)) {
				Constants.consumptionByUse[1] = settings.consumptionwashing
			}
			if(settings.consumptioncleaning && !isNaN(settings.consumptioncleaning)) {
				Constants.consumptionByUse[2] = settings.consumptioncleaning
			}

			if(settings.useavailablerainwaterintanksizecalculation && !isNaN(settings.useavailablerainwaterintanksizecalculation)) {
				Constants.useAvailableRainwaterInTankSizeCalculation = true;
			}

			$('[data-replaceconsumption]').each((index, resultContainer) => {
				const $resultContainer = $(resultContainer),
					consumptionIndex = parseInt($resultContainer.data('replaceconsumption'));

				if(!isNaN(consumptionIndex)) {
					$resultContainer.html(
						$resultContainer.html().replace(/%s/, Constants.consumptionByUse[consumptionIndex].toLocaleString())
					);
				}
			});
		}

		bindHandlers() {
			this.calculationsContainer.show();

			this.roofTypeSelect.on('change', e => {
				this.roofCoefficientInput.val(
					parseFloat(this.roofTypeSelect.find(':selected').data('coefficient'))
				);
			});

			this.roofAreaDummyInput.on('change', e => {
				this.roofAreaInput.val(e.target.value);
			});


			const inputs = this._$element.find('input, select');
			inputs.on('change', e => {
				if (e && e.target && e.target.type !== "hidden") {
					this.updateResults();
				}
			});

			if(this.addressAutocomplete) {
				this.zipInput.off('change');

				this.addressAutocomplete.addListener('place_changed', () => {
					this.zipInput.val(this.addressAutocomplete.getPlace().formatted_address);
					this.updateResults();
				});
				this.zipInput.on('blur', () => {
					const place = this.addressAutocomplete.getPlace();
					if(place) {
						this.zipInput.val(place.formatted_address);
					}
				});
			}

			if(this.addressAutocomplete && this.countrySelect) {
				this.countrySelect.on('input', () => this.setAutocompleteCountry());
			}
		}

		setAutocompleteCountry() {
			this.addressAutocomplete.setComponentRestrictions({
				'country': Constants.countryCodes[parseInt(this.countrySelect.val())]
			});
			this.zipInput.val('');
		}

		updateResults() {
			const formData = this.getFormData(false),
				skipCalculation = !this.precipitation(formData) || !formData.roofType || !formData.typeOfUse,
				tankSize = skipCalculation ? 0 : this.tankSize(formData);
			let waterDemand = 0,
				waterYield = 0;

			this.calculationsContainer.toggleClass('hide', skipCalculation);
			this.tankSizeInput.val(tankSize);

			const selectedRoofType = this.roofTypeSelect.find(':selected');
			this.exportPdfResults.show();
			if (selectedRoofType && parseInt(selectedRoofType.data('stop')) === 1) {
				if (selectedRoofType.data('text')) {
					this.showResults(`<div class="row">
			<div class="xsmall-8 medium-6 columns medium-offset-6 large-5 columns large-offset-7">
				<a href="${this.roofTypeSelect.data('contactpagelink')}" class="button primary large expanded contactSalesTeam">
					${this.roofTypeSelect.data('buttonlabel')}
				</a>
				<div class="tank-advisor-error">
					${selectedRoofType.data('text')}
				</div>
			</div>
		</div>`);
				}

				// Hide pdf download button without results
				this.exportPdfResults.hide();
				return;
			}

			if (!skipCalculation) {
				// Calculate water demand and yield and save it to form fields
				// we need this to get those infos into the session and from there into the cta mail
				waterDemand= this.waterDemand(formData);
				waterYield = this.waterYield(formData);
				this.waterDemandInput.val(waterDemand);
				this.waterYieldInput.val(waterYield);

				this.updateCalculationResults({
					...formData,
					tankSize,
					waterDemand,
					waterDemandByUse: this.waterDemandByUse,
					waterYield,
					savings: isNaN(this.precipitationWaterChargeSavings(formData)) ? NaN : this.savings(formData),
					precipitationWaterChargeSavings: this.precipitationWaterChargeSavings(formData),
					yearlySavings: this.yearlySavings(formData)
				});
			}

			const serializedFormData = this.getFormData(true);
			this.setFormData({
				...serializedFormData,
				'tx_igtankadvisor_productdisplay[advisor][tankSize]': tankSize,
				'tx_igtankadvisor_productdisplay[advisor][waterDemand]': waterDemand,
				'tx_igtankadvisor_productdisplay[advisor][waterDemandToilet]': this.waterDemandByUse[0] || 0,
				'tx_igtankadvisor_productdisplay[advisor][waterDemandWashing]': this.waterDemandByUse[1] || 0,
				'tx_igtankadvisor_productdisplay[advisor][waterDemandCleaning]': this.waterDemandByUse[2] || 0,
				'tx_igtankadvisor_productdisplay[advisor][waterDemandGarden]': this.waterDemandByUse[3] || 0,
				'tx_igtankadvisor_productdisplay[advisor][waterYield]': waterYield,
				'tx_igtankadvisor_productdisplay[advisor][savings]': isNaN(this.precipitationWaterChargeSavings(formData)) ? 0 : this.savings(formData),
				'tx_igtankadvisor_productdisplay[advisor][precipitationWaterChargeSavings]': isNaN(this.precipitationWaterChargeSavings(formData)) ? 0 : this.precipitationWaterChargeSavings(formData),
				'tx_igtankadvisor_productdisplay[advisor][yearlySavings]': this.yearlySavings(formData)
			}, this.pdfExportForm[0]);
			this.saveFormData(serializedFormData);

			if (this.currentUpdateRequest) {
				this.currentUpdateRequest.abort();
			}

			serializedFormData['tx_igtankadvisor_productdisplay[controller]'] = 'TankAdvisor';
			serializedFormData['tx_igtankadvisor_productdisplay[action]'] = 'advise';
			serializedFormData['type'] = '3421';

			this.loadingIndicator.show();

			this.currentUpdateRequest = $.ajax({
				url: CLEAN_URL + '?type=3421',
				method: 'POST',
				data: serializedFormData,
				success: response => this.showResults(response)
			});
		}

		/**
		 * Display calculation results in prepared html markers
		 * any element with a data attribute matching a key in formData will be replaced
		 * @param formData
		 */
		updateCalculationResults(formData) {
			const results = Object.entries(formData);
			for(const [key, value] of results) {
				// replaces any elements with data-[key] with their corresponding value
				const dataKey = `[data-${key.toLowerCase()}]`;
				$(dataKey).each((index, resultContainer) => {
					const $resultContainer = $(resultContainer),
						dataValue = parseInt($resultContainer.data(key.toLowerCase()));

					if(!isNaN(dataValue) && value.hasOwnProperty(dataValue)) {
						$resultContainer.html(value[dataValue].toLocaleString());
					} else {
						$resultContainer.html(value.toLocaleString());
					}
				});

				const visibilityKey = `[data-if${key.toLowerCase()}]`;
				$(visibilityKey).each((index, container) => {
					const $container = $(container),
						dataValue = parseInt($container.data(`if${key.toLowerCase()}`));

					if(Array.isArray(value)) {
						$container.toggleClass('hide', !value.includes(dataValue));

						// hide garden calculation if there is no garden area
						if (dataValue === Constants.typesOfUse.GARDEN && formData.gardenArea === 0) {
							$container.addClass('hide');
						}
					} else {
						$container.toggleClass('hide', !formData.hasOwnProperty(key) || isNaN(formData[key]));
					}
				});
			}

			//this.tankSizeTooltip.foundation('_destroy');
			const tankSizeTooltip = this.tankSizeTooltip.data('originaltooltip')
				.replace(/{waterYield}/, formData.waterYield)
				.replace(/{demand}/, formData.waterDemand)
				.replace(/{securityReserve}/, formData.securityReserve)
				.replace(/{tankSize}/, formData.tankSize);

			new Foundation.Tooltip(this.tankSizeTooltip, {
				tipText: tankSizeTooltip,
				allowHtml: true
			});

			// display error when water demand surpasses current water yield
			this.errors.yieldInsufficient.toggleClass('hide', formData.waterYield >= formData.waterDemand);

			this.exportPdfResults.show();
			if (formData.waterYield < formData.waterDemand) {
				// Hide pdf download button id waterDemand > waterYield
				this.exportPdfResults.hide();
			}

			// hide number of people input when only garden usage is selected
			this.numberOfPeopleInput.toggleClass('hide', formData.typeOfUse.includes(Constants.typesOfUse.GARDEN) && formData.typeOfUse.length === 1);
		}

		showResults(response) {
			this.currentUpdateRequest = null;
			this.loadingIndicator.hide();
			this.resultsContainer.html(response);
			this.updateSavedResults();
		}

		updateSavedResults() {
			const articleUids = this.resultsContainer.find(Selectors.ARTICLE).toArray().map(article => {
				return $(article).data('uid');
			});
			localStorage.setItem('advisorResults', JSON.stringify(articleUids));
		}

		waterDemand(formData) {
			if(!formData.hasOwnProperty('typeOfUse')) {
				return 0;
			}

			return formData['typeOfUse'].reduce((carry, typeOfUse) => {
				if (typeOfUse === 3) {
					// demand calculation for gardening
					this.waterDemandByUse[typeOfUse] = formData.gardenArea * formData.gardenIrrigation;
				} else {
					// demand calculation for other uses
					this.waterDemandByUse[typeOfUse] = formData.numberOfPeople * Constants.consumptionByUse[typeOfUse] * 1000;
				}
				return carry + this.waterDemandByUse[typeOfUse];
			}, 0);
		}

		waterYield(formData) {
			return this.precipitation(formData) * formData.roofArea * formData.roofCoefficient;
		}

		precipitation(formData) {
			if(formData['precipitation']) {
				return formData['precipitation'];
			}

			if(formData.hasOwnProperty('zip') && formData.hasOwnProperty('country') && (formData.zip || this.addressAutocomplete)) {
                let zip = formData.zip.toString();
                const precipitationData = Object.entries(Constants.precipitationByZip[formData.country]);
                if (this.addressAutocomplete) {
                    const place = this.addressAutocomplete.getPlace();

                    if(place && place.address_components) {
                        const zipComponent = place.address_components.find(component => {
                            return component.types[0] === "postal_code";
                        });
                        zip = zipComponent.short_name;
                    }
                }

				while (zip.length > 0) {
					for (const [key, value] of precipitationData) {
						if (key === zip) {
							return value;
						}
					}
					zip = zip.slice(0, -1);
				}
			}

			return 0;
		}

		tankSize(formData) {
			if(Constants.useAvailableRainwaterInTankSizeCalculation) {
				return Math.round((this.waterYield(formData) + this.waterDemand(formData)) / 2 * (formData.securityReserve / 365));
			} else {
				return Math.round(this.waterDemand(formData) * (formData.securityReserve / 365));
			}
		}

		savings(formData) {
			return Math.round(this.waterDemand(formData) * formData.waterPrice / 1000);
		}

		precipitationWaterChargeSavings(formData) {
			return Math.round(formData.roofArea * formData.precipitationWaterCharge * formData.dischargeCoefficient / 100);
		}

		yearlySavings(formData) {
			if(this.precipitationWaterChargeSavings(formData)) {
				return this.precipitationWaterChargeSavings(formData) + this.savings(formData);
			}
			return this.savings(formData);
		}

		getFormData(fullIdentifier = false) {
			return this._$element.serializeArray().reduce((carry, formValue) => {
				const identifiers = formValue.name.match(/\[(.*?)]/g);
				if ((fullIdentifier || identifiers[0] === "[advisor]") && formValue.value) {
					const key = fullIdentifier ? formValue.name.replace(/\[]]$/, '][]') : identifiers[1].replace(/[\[\]]/g, ''),
						value = fullIdentifier || key === "zip" ? formValue.value : parseFloat(formValue.value);

					if (formValue.name.match(/\[]/)) {
						// formValue is array
						if (!carry.hasOwnProperty(key)) {
							carry[key] = [];
						}
						carry[key].push(value);
						return carry;
					}

					carry[key] = value;
					return carry;
				}

				return carry;
			}, {});
		}

		saveFormData(formData) {
			if(window.hasOwnProperty('localStorage')) {
				localStorage.setItem('tankAdvisorData', JSON.stringify(formData));
				return true;
			}
			return false;
		}

		recoverFormData() {
			if(window.hasOwnProperty('localStorage')) {
				return JSON.parse(localStorage.getItem('tankAdvisorData'));
			}
			return false;
		}

		setFormData(formData, form) {
			if (formData) {
				const elements = form.elements;
				for (let input of elements) {
					const inputName = input.name.replace(/\[]]$/, '][]'),
						value = formData[inputName];

					if (formData.hasOwnProperty(inputName) && inputName.match(/\[advisor]/)) {
						if (inputName.match(/\[]$/) && input.type === "hidden") {
							continue;
						}
						// if resilience is a hidden field do not load it from local storage - settings.disableResilience = 0
						// exclude exportForm, there are only hidden fields!
						if (form.id !== 'tankAdvisor-exportForm' && inputName.match(/\[resilience]/) && input.type === "hidden") {
							continue;
						}

						if (input.type === "radio") {
							input.checked = value === input.value;
						} else if (input.type === "checkbox") {
							input.checked = typeof(value) === "object" ? value.includes(input.value) : value;
						} else {
							input.value = value;
						}
					}
				}

				// Set roofAreaDummy always to same value as roofArea
				this.roofAreaDummyInput.val(this.roofAreaInput.val());
			}
		}
	}

	return AdvisorForm._getElement($body.find(Selectors.ADVISOR_FORM), AdvisorForm);
})();

export default AdvisorForm;
